import React from 'react';
import PropTypes from 'prop-types';
import { Trans } from 'lingui-react';
import { withTheme } from 'styled-components';
import { compose, setDisplayName } from 'recompose';

import { Icon, Text } from 'base-components';
import { Row, Column } from 'styled-components-reactive-grid';

import withCaseSavingStatus from './withCaseSavingStatus';

export function SaveIndicator({
  isSaving,
  theme: {
    colors: {
      base: { chrome300 },
    },
  },
}) {
  const iconModifier = isSaving ? '' : 'success';
  const iconStyles = isSaving ? { color: chrome300 } : undefined;

  return (
    <Row modifiers="middle">
      <Column modifiers="padScaleY_0">
        <Icon
          name="check-circle-f"
          style={iconStyles}
          modifiers={iconModifier}
        />
      </Column>
      <Column modifiers="padScale_0">
        <Text modifiers="small">
          {isSaving ? (
            <Trans>Saving...</Trans>
          ) : (
            <Trans>All changes saved</Trans>
          )}
        </Text>
      </Column>
    </Row>
  );
}

SaveIndicator.propTypes = {
  isSaving: PropTypes.bool.isRequired,
  // Used by withCaseSavingStatus
  // eslint-disable-next-line react/no-unused-prop-types
  caseNumber: PropTypes.string.isRequired,
  theme: PropTypes.shape({
    colors: PropTypes.shape({
      base: PropTypes.shape({
        chrome300: PropTypes.string.isRequired,
      }).isRequired,
    }).isRequired,
  }).isRequired,
};

export default compose(
  setDisplayName('SaveIndicator'),
  withCaseSavingStatus,
  withTheme,
)(SaveIndicator);



// WEBPACK FOOTER //
// ./src/compositions/CaseDetailOverviewPanel/SaveIndicator.js